import { render, staticRenderFns } from "./AddEditMaterial.vue?vue&type=template&id=d22b5e38&scoped=true&"
import script from "./AddEditMaterial.vue?vue&type=script&lang=js&"
export * from "./AddEditMaterial.vue?vue&type=script&lang=js&"
import style0 from "./AddEditMaterial.vue?vue&type=style&index=0&id=d22b5e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22b5e38",
  null
  
)

export default component.exports